import React from 'react';
import { AnswerType, IRenderingEngine } from '../interfaces/index.type';
import Amount from './Amount';
import Date from './Date';
import Options from './Options';
import Text from './Text';
import Time from './Time';
import PhoneNumber from './PhoneNumber';
import RadioGroupOptions from './RadioOptions';
import ImageUpload from './ImageUpload';
import CheckboxOptions from '@cp/pages/CaseDetails/feedbackForm/component/CheckboxOptions';
import TextAreaInput from '@cp/pages/CaseDetails/feedbackForm/component/TextAreaInput';
import GroupedOptions from '@cp/pages/CaseDetails/feedbackForm/component/GroupedOptions';
import AudioUpload from './AudioUpload';

const RenderingEngine: React.FC<IRenderingEngine> = props => {
  const { question, source } = props;
  const { text, referenceId } = question;
  if (question.answerType === AnswerType.REMINDER) return null;
  return (
    <div key={`${source}_${referenceId}_${text}`}>
      {question.answerType === AnswerType.AMOUNT ? (
        <Amount {...props} />
      ) : question.answerType === AnswerType.DATE ? (
        <Date {...props} />
      ) : question.answerType === AnswerType.OPTIONS ? (
        <Options {...props} />
      ) : question.answerType === AnswerType.TIME ? (
        <Time {...props} />
      ) : question.answerType === AnswerType.TEXT ? (
        <Text {...props} />
      ) : question.answerType === AnswerType.PHONE_NUMBER ? (
        <PhoneNumber {...props} />
      ) : question.answerType === AnswerType.RADIO_OPTIONS ? (
        <RadioGroupOptions {...props} />
      ) : question.answerType === AnswerType.MULTI_IMAGE_UPLOAD ? (
        <ImageUpload {...props} />
      ) : question.answerType === AnswerType.CHECKBOX_OPTIONS ? (
        <CheckboxOptions {...props} />
      ) : question.answerType === AnswerType.TEXTAREA ? (
        <TextAreaInput {...props} />
      ) : question.answerType === AnswerType.GROUPED_OPTIONS ? (
        <GroupedOptions {...props} />
      ) : question.answerType === AnswerType.MULTI_AUDIO_UPLOAD ? (
        <AudioUpload {...props} />
      ) : null}
    </div>
  );
};

export default RenderingEngine;
